const MENU_TYPES = {
    DETAIL: "detail",
    VISIBILITY: "visibility",
    LOCATIONS: "locations",
    REVIEWS: "reviews",
};

const Items = (that) => [
    {
        enabled: true,
        key: MENU_TYPES.DETAIL,
        label: that?.$t("googleBusiness.detail") || "Detail",
        icon: {
            type: "material-icons",
            name: "info",
        },
    },
    {
        enabled: false,
        key: MENU_TYPES.VISIBILITY,
        label: that?.$t("googleBusiness.visibility") || "Visibility",
        icon: {
            type: "material-icons",
            name: "visibility",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.LOCATIONS,
        label: that?.$t("googleBusiness.locations") || "Locations",
        icon: {
            type: "material-icons",
            name: "location_on",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.REVIEWS,
        label: that?.$t("googleBusiness.reviews") || "Reviews",
        icon: {
            type: "material-icons",
            name: "star",
        },
    },
];

export default {
    MENU_TYPES,
    Items,
};
